import { FileCategory, FileCategoryKunden } from "../models/download-model";

/**
 * Array of file categories, each containing a German title, English description, and optional files or subsections.
 * 
 * @type {FileCategory[]}
 */
export const fileCategories: FileCategory[] = [
  {
    germanTitle: "Anlagenaufnahme",
    englishDescription: "plant_recording",
    files: [
      {
        fileName: "AC Vorlage IW Anlagenaufnahme VKA",
        fileUrl: "AC_Vorlage IW_Anlagenaufnahme_VKA_210420.pdf",
      },
      {
        fileName: "AC Vorlage IW Anlagenaufnahme NA",
        fileUrl: "AC_Vorlage IW_Anlagenaufnahme_NA_210507.pdf",
      },
      {
        fileName: "Schicht Vorlage IW Anlagenaufnahme NA",
        fileUrl: "S_Vorlage IW_Anlagenaufnahme_NA_210507.pdf",
      },
      {
        fileName: "Schicht Vorlage IW Anlagenaufnahme VKA",
        fileUrl: "S_Vorlage IW_Anlagenaufnahme_VKA_210420.pdf",
      },
    ],
  },
  {
    germanTitle: "Bedienungsanleitungen",
    englishDescription: "operating_instructions",
    files: [{ fileName: "dummy.pdf", fileUrl: "dummy.pdf" }],
  },
  {
    germanTitle: "Checklisten",
    englishDescription: "checklists",
    files: [
      {
        fileName: "Angebotsanforderung",
        fileUrl: "Angebotsanforderung_V20.4_201022_ET.pdf",
      },
      {
        fileName: "Checkliste Dosierpumpe",
        fileUrl: "Checkliste_Dosierpumpe_V20.4_201022_ET.pdf",
      },
      {
        fileName: "Checkliste Enthärtungsanlage",
        fileUrl: "Checkliste_Enthärtungsanlage_V20.4_201022_ET.pdf",
      },
      {
        fileName: "Checkliste Absalzanlage",
        fileUrl: "Checkliste_Absalzanlage_V20.4_201022_ET.pdf",
      },
      {
        fileName: "Checkliste Umkehrosmose",
        fileUrl: "Checkliste_Umkehrosmose_V20.4_201022_ET.pdf",
      },
      {
        fileName: "Checkliste Projektierung: Reinigung-Entkalkung-Entrostung",
        fileUrl:
          "Checkliste_Projektierung_Reinigung-Entkalkung-Entrostung_V20.4_201022_ET.pdf",
      },
    ],
  },
  {
    germanTitle: "Inbetriebnahmeprotokolle",
    englishDescription: "commissioning_report",
    files: [
      {
        fileName: "AC Inbetriebnahmeprotokoll Enthärtungsanlagen",
        fileUrl:
          "AC_Inbetriebnahmeprotokoll_Enthärtungsanlagen_V22.2_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Druckerhöhung",
        fileUrl:
          "AC_Inbetriebnahmeprotokoll_Druckerhöhung_V22.2_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Dosierpumpe",
        fileUrl:
          "AC_Inbetriebnahmeprotokoll_Dosierpumpe_V22.2_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Absalzanlage",
        fileUrl:
          "AC_Inbetriebnahmeprotokoll_Absalzanlage_V22.2_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll GRÜNBECK Enthärtungsanlage",
        fileUrl: "AC_Inbetriebnahmeprotokoll_GRÜNBECK_Enthärtungsanlage_V22.2_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Härtekontrollgerät",
        fileUrl: "AC_Inbetriebnahmeprotokoll_Härtekontrollgerät_V22.2_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Sandfilter",
        fileUrl: "AC_Inbetriebnahmeprotokoll_Sandfilter_V22.4_220504_ET.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Systemtrenner",
        fileUrl: "AC_Inbetriebnahmeprotokoll_Systemtrenner_V22.2_220504_ET_.pdf",
      },
      {
        fileName: "AC Inbetriebnahmeprotokoll Umkehrosmoseanlage",
        fileUrl: "AC_Inbetriebnahmeprotokoll_Umkehrosmoseanlage_V22.2_220504_ET.pdf",
      },
            {
        fileName: "S Inbetriebnahmeprotokoll Absalzanlage",
        fileUrl: "S_Inbetriebnahmeprotokoll_Absalzanlage_V22.2_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Dosierpumpe",
        fileUrl: "S_Inbetriebnahmeprotokoll_Dosierpumpe_V22.2_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Druckerhöhung",
        fileUrl: "S_Inbetriebnahmeprotokoll_Druckerhöhung_V22.2_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Enthärtungsanlagen",
        fileUrl: "S_Inbetriebnahmeprotokoll_Enthärtungsanlagen_V22.2_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll GRÜNBECK Enthärtungsanlage",
        fileUrl: "S_Inbetriebnahmeprotokoll_GRÜNBECK_Enthärtungsanlage_V22.2_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Härtekontrollgerät",
        fileUrl: "S_Inbetriebnahmeprotokoll_Härtekontrollgerät_V22.2_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Sandfilter",
        fileUrl: "S_Inbetriebnahmeprotokoll_Sandfilter_V22.4_220504_ET.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Systemtrenner",
        fileUrl: "S_Inbetriebnahmeprotokoll_Systemtrenner_V22.2_220504_ET_.pdf",
      },
      {
        fileName: "S Inbetriebnahmeprotokoll Umkehrosmoseanlage",
        fileUrl: "S_Inbetriebnahmeprotokoll_Umkehrosmoseanlage_V22.2_220504_ET.pdf",
      },
    ],
  },
  {
    germanTitle: "Leistungsnachweise",
    englishDescription: "proof_of_performance",
    files: [
      {
        fileName: "Leistungsnachweis Montage und Reparatur",
        fileUrl: "Leistungsnachweis Montage Reparatur_V02.pdf",
      },
      {
        fileName: "Leistungsnachweis Service",
        fileUrl: "Leistungsnachweis Service_V03.pdf",
      },
    ],
  },
  {
    germanTitle: "Vorschriften",
    englishDescription: "rules",
    subSections: [
      {
        title: "Kesselwasser",
        files: [
          {
            fileName: "DIN EN 12953-1",
            fileUrl: "DIN_EN_12953_1_05_2012.pdf",
          },
          {
            fileName: "IAPWS Richtlinie Filmbildende Substanzen",
            fileUrl: "IAPWS Guideline Filmbildende Substanzen.pdf",
          },
          {
            fileName: "Loos Wasser B002",
            fileUrl: "Loos-Wasser-B002-082010.pdf",
          },
          { fileName: "TRBS 2141", fileUrl: "TRBS-2141.pdf" },
          {
            fileName: "TRBS 2141 Änderungen",
            fileUrl: "TRBS-2141-Aenderungen.pdf",
          },
          {
            fileName: "TRD 611 Juli 2005",
            fileUrl: "TRD 611 Juli 2005.pdf",
          },
          {
            fileName: "TRD 611 tab1-5b",
            fileUrl: "TRD_611-tab1-5b.pdf",
          },
          {
            fileName: "TRGS 608 Hydrazinersatz",
            fileUrl: "TRGS 608_Hydrazinersatz.pdf",
          },
          {
            fileName: "TRGS 615",
            fileUrl: "TRGS 615-05-2007-090818-tp.pdf",
          },
          { fileName: "TRGS 611", fileUrl: "TRGS-611-Mai-2007.pdf" },
          {
            fileName: "Übersicht TRD Regelwerk",
            fileUrl: "Übersicht-TRD-Regelwerk-060904-tp.pdf",
          },
          {
            fileName: "vgbe-s-010-00-2023-08-de_ebook-su__1",
            fileUrl: "vgbe-s-010-00-2023-08-de_ebook-su__1.pdf",
          },
        ],
      },
      {
        title: "Offene Systeme",
        files: [
          { fileName: "VDMA 24649", fileUrl: "VDMA24649.pdf" },
          {
            fileName: "VDI 2047 Blatt 2",
            fileUrl: "VDI 2047 Blatt 2_2019-01.pdf",
          },
          {
            fileName: "VDI-MT 2047 Blatt 4",
            fileUrl: "VDI-MT 2047 Blatt 4_2019-01.pdf",
          },
          {
            fileName: "VDI 3679 Blatt 1",
            fileUrl: "VDI 3679 Blatt 1_07_2014.pdf",
          },
          {
            fileName: "VDI 3679 Blatt 2",
            fileUrl: "VDI 3679 Blatt 2_2014-07.pdf",
          },
          {
            fileName: "VDI 3679 Blatt 3",
            fileUrl: "VDI 3679 Blatt 3_2019-08.pdf",
          },
          { fileName: "VDI 4223", fileUrl: "VDI 4223_2020-03.pdf" },
          {
            fileName: "VDI 4250 Blatt 1",
            fileUrl: "VDI 4250 Blatt1_08-2014_150127-tp.pdf",
          },
          {
            fileName: "VDI 4259 Blatt 1",
            fileUrl: "VDI 4259 Blatt 1_11-2019.pdf",
          },
          { fileName: "TRGS 400", fileUrl: "TRGS-400.pdf" },
          { fileName: "TRGS 500", fileUrl: "TRGS-500.pdf" },
          {
            fileName: "TRBA 400",
            fileUrl: "TRBA-400 Ausgabe März 2018.pdf",
          },
          {
            fileName: "Legionellenempfehlung",
            fileUrl:
              "legionellenempfehlung_2020_03_06_uba_format_0.pdf",
          },
          {
            fileName: "LAI-Auslegungsfragen 42-bimschv-aktualisierung-1",
            fileUrl:
              "LAI-Auslegungsfragen-42-bimschv-aktualisierung_220912-1.pdf",
          },
          {
            fileName: "LAI-Auslegungsfragen 42-bimschv-aktualisierung",
            fileUrl:
              "LAI-Auslegungsfragen-42-bimschv-aktualisierung_220912.pdf",
          },
          {
            fileName: "Checkliste Biostoff GBU",
            fileUrl: "Checkliste Biostoff GBU.pdf",
          },
          {
            fileName: "Anlage 2 beschreibbar",
            fileUrl: "Anlage 2 beschreibbar.pdf",
          },
          {
            fileName: "Agenda für Online Schulungen",
            fileUrl: "Agenda für Online Schulungen.pdf",
          },
          { fileName: "42BImSchV", fileUrl: "42_BImSchV_final.pdf" },
          {
            fileName: "UM-BioStV Kunz Gefährdungsbeurteilung Kühlwasseranlage",
            fileUrl:
              "14-10-16_UM-BioStV Kunz Gefährdungsbeurteilung Kühlwasseranlage.pdf",
          },
        ],
      },
      {
        title: "Geschlossene Systeme",
        files: [
          {
            fileName: "VDI 2035 Blatt 1",
            fileUrl: "VDI_2035-1.pdf",
          },
          {
            fileName: "VDI 2035 Blatt 2",
            fileUrl: "VDI 2035 Blatt 2.pdf",
          },
          {
            fileName: "VDI 6041",
            fileUrl: "VDI_6041_2025-07.pdf"
          },
          { fileName: "VDI 6044", fileUrl: "VDI_6044_V01.pdf" },
          {
            fileName: "Betriebsbuch VDI 6044 Version 3",
            fileUrl: "2023-09-01 Betriebsbuch VDI 6044_V03.pdf",
          },
          {
            fileName: "Anlagenbuch VDI 6044 Version 1",
            fileUrl: "2023-09-01 Anlagenbuch VDI 6044_V01.pdf",
          },
          { fileName: "VDI RL", fileUrl: "VDI_RL_2035_2.pdf" },
        ],
      },
      {
        title: "Sonstiges",
        files: [
          {
            fileName: "Wann ist ein Sicherheitsdatenblatt erforderlich?",
            fileUrl:
              "Wann ist ein Sicherheitsdatenblatt erforderlich.pdf",
          },
          {
            fileName: "Erneuerung der Trinkwasserverordnung",
            fileUrl: "Erneuerung der Trinkwasserverordnung.pdf",
          },
          { fileName: "WSP", fileUrl: "WSP.pdf" },
          {
            fileName: "VDI 2067 Blatt 2",
            fileUrl: "VDI 2067_Blatt 22_2023-05_230628.pdf",
          },
          {
            fileName: "VDI 2070",
            fileUrl: "VDI 2070_03-2013-150316-tp.pdf",
          },
          {
            fileName: "VDI 3810 Blatt 2",
            fileUrl: "VDI 3810 Blatt2_05-2010-150128-tp.pdf",
          },
          {
            fileName: "VDI 6023 Blatt 1",
            fileUrl: "VVDI 6023_Blatt 1_2022-09.pdf",
          },
          {
            fileName: "VDI 6023 Blatt 2",
            fileUrl: "VDI 6023_Blatt 2_2018-01.pdf",
          },
          {
            fileName: "VDI 6023 Blatt 4",
            fileUrl: "VDI 2070_03-2013-150316-tp.pdf",
          },
        ],
      },
    ],
  },
  {
    germanTitle: "Wartungsprotokolle",
    englishDescription: "maintenance_reports",
    files: [
 {
        fileName: "AC Wartungsprotokoll Absalzanlage",
        fileUrl:
          "AC_Wartungsprotokoll_Absalzanlage V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Dosierpumpe",
        fileUrl:
          "AC_Wartungsprotokoll_Dosierpumpe V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Druckerhöhung",
        fileUrl:
          "AC_Wartungsprotokoll_Druckerhöhung V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Enthärtungsanlagen",
        fileUrl:
          "AC_Wartungsprotokoll_Enthärtungsanlagen V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Filter",
        fileUrl: "AC_Wartungsprotokoll_Filter V22.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll GRÜNBECK Enthärtungsanlage",
        fileUrl: "AC_Wartungsprotokoll_GRÜNBECK_Enthärtungsanlage V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Härtekontrollgerät",
        fileUrl: "AC_Wartungsprotokoll_Härtekontrollgerät V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Sandfilter",
        fileUrl: "AC_Wartungsprotokoll_Sandfilter V20.4_201022_ET.pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Systemtrenner",
        fileUrl: "AC_Wartungsprotokoll_Systemtrenner V20.4_201022_ET .pdf",
      },
      {
        fileName: "AC Wartungsprotokoll Umkehrosmoseanlage",
        fileUrl: "AC_Wartungsprotokoll_Umkehrosmoseanlage V20.02_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Absalzanlage",
        fileUrl: "S_Wartungsprotokoll_Absalzanlage V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Dosierpumpe",
        fileUrl: "S_Wartungsprotokoll_Dosierpumpe V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Druckerhöhung",
        fileUrl: "S_Wartungsprotokoll_Druckerhöhung V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Enthärtungsanlagen",
        fileUrl: "S_Wartungsprotokoll_Enthärtungsanlagen V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Filter",
        fileUrl: "S_Wartungsprotokoll_Filter V22.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll GRÜNBECK Enthärtungsanlage",
        fileUrl: "S_Wartungsprotokoll_GRÜNBECK_Enthärtungsanlage V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Härtekontrollgerät",
        fileUrl: "S_Wartungsprotokoll_Härtekontrollgerät V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Sandfilter",
        fileUrl: "S_Wartungsprotokoll_Sandfilter V20.4_201022_ET.pdf",
      },
      {
        fileName: "S Wartungsprotokoll Systemtrenner",
        fileUrl: "S_Wartungsprotokoll_Systemtrenner V20.4_201022_ET .pdf",
      },
      {
        fileName: "S Wartungsprotokoll Umkehrosmoseanlage",
        fileUrl: "S_Wartungsprotokoll_Umkehrosmoseanlage V20.02_201022_ET.pdf",
      },
    ],
  },
  {
    germanTitle: "Sonstiges",
    englishDescription: "miscellaneous",
    files: [
      {
        fileName: "Dekonaminationserklärung",
        fileUrl: "Dekonaminationserklärung_20200624.pdf",
      },
      {
        fileName: "PFAS Hersteller Erklärung",
        fileUrl:"AC_PFAS_250911_DE-tp.pdf"
      }
    ],
  },
  {
    germanTitle: "Reinigungen",
    englishDescription: "miscellaneous",
    files: [
      {
        fileName: "Cleaning instruction for Decalcit T 610 and 131",
        fileUrl:
          "Cleaning instruction for Decalcit T 610 and 131_EN.pdf",
      },
      {
        fileName: "DC131 610 Anwendungsblatt",
        fileUrl: "DC131_610Anwendungsblatt.pdf",
      },
      {
        fileName: "AC Haftungsvereinbarung für spezielle Dienstleitungen",
        fileUrl:
          "Haftungsvereinbarung für spezielle Dienstleitungen_AC.pdf",
      },
      {
        fileName: "AC Haftungsvereinbarung für spezielle Dienstleitungen-1",
        fileUrl:
          "Haftungsvereinbarung für spezielle Dienstleitungen_AC-1.pdf",
      },
      {
        fileName: "Schicht Haftungsvereinbarung für spezielle Dienstleitungen",
        fileUrl:
          "Haftungsvereinbarung für spezielle Dienstleitungen_SC.pdf",
      },
      {
        fileName: "AC Bedingungen für chemische Reinigung",
        fileUrl: "Bedingungen für chemische Reinigung_AC.pdf",
      },
      {
        fileName: "Schicht Bedingungen für chemische Reinigung",
        fileUrl: "Bedingungen für chemische Reinigung_SC.pdf",
      },
      {
        fileName: "Schicht Bedingungen für chemische Reinigung-1",
        fileUrl: "Bedingungen für chemische Reinigung_SC-1.pdf",
      },
      {
        fileName: "Checkliste/Leitfaden saure Reinigung",
        fileUrl: "Checkliste Leitfaden saure Reinigung.pdf",
      },
    ],
  },
];

/**
 * Array of customer-specific file categories, each containing a German title, English description, and optional file URL.
 * 
 * @type {FileCategoryKunden[]}
 */
export const coraconCategories: FileCategoryKunden[] = [
  {
    germanTitle: "WTF Geothermie",
    englishDescription: "geothermal_energy",
    fileUrl: "dummy.pdf",
  },
  {
    germanTitle: "WTF Solarthermie",
    englishDescription: "solar_energy",
    fileUrl: "dummy.pdf",
  },
  {
    germanTitle: "WTF Gebäude- und Anlagentechnik",
    englishDescription: "building_technology",
    fileUrl: "dummy.pdf",
  },
  {
    germanTitle: "Heizung",
    englishDescription: "heater",
    fileUrl: "dummy.pdf",
  },
  {
    germanTitle: "Superkonzentrate",
    englishDescription: "super_concentrated",
    fileUrl: "dummy.pdf",
  },
  {
    germanTitle: "Sonstiges",
    englishDescription: "miscellaneous",
    fileUrl: "dummy.pdf",
  },
];

/**
 * Array of brochure sections, each containing a German title, English description, and optional file URL.
 * 
 * @type {FileCategoryKunden[]}
 */
export const brochureSection: FileCategoryKunden[] = [
  {
    germanTitle: "AC Unternehmensvorstellung",
    englishDescription: "geothermal_energy",
    fileUrl: "aqua-concept Unternehmensvorstellung_20220414.pdf",
  },
  {
    germanTitle: "Broschüre Bioticare",
    englishDescription: "geothermal_energy",
    fileUrl: "AC_bioticare_Broschüre.pdf",
  },
  {
    germanTitle: "Broschüre Springbrunnen_2018",
    englishDescription: "geothermal_energy",
    fileUrl: "Broschüre Springbrunnen_2018.pdf",
  },
  {
    germanTitle: "Broschüre Kühlwasser_2018",
    englishDescription: "geothermal_energy",
    fileUrl: "Broschüre Kühlwasser_2018.pdf",
  },
  {
    germanTitle: "Broschüre Sprinkleranlagen_2019",
    englishDescription: "geothermal_energy",
    fileUrl: "Broschüre Sprinkleranlagen_2019.pdf",
  },
  {
    germanTitle: "Coracon VDI6044",
    englishDescription: "geothermal_energy",
    fileUrl: "AC_coracon_VDI6044.pdf",
  },
  {
    germanTitle: "Coracon´Service und Energie",
    englishDescription: "geothermal_energy",
    fileUrl: "AC_coracon_Service_und _Energie.pdf",
  },
  {
    germanTitle: "C3 - Careblue Control Center",
    englishDescription: "geothermal_energy",
    fileUrl: "AC_Careblue Control Center_C3.pdf",
  },
  {
    germanTitle:"Auftrag careblue Systemwasseranalyse",
    englishDescription: "geothermal_energy",
    fileUrl:"Auftrag_careblue_Systemwasseranalyse_AC.pdf"
  }
];

/**
 * Array of sections for various categories, each containing a German title, English description, and optional subsections.
 * 
 * @type {FileCategoryKunden[]}
 */
export const enthSection: FileCategoryKunden[] = [
];

export const filterSection: FileCategoryKunden[] = [
];

export const umkehrosmoseSection: FileCategoryKunden[] = [
];

export const chemieSection: FileCategoryKunden[] = [
];

export const dosiertechnikSection: FileCategoryKunden[] = [
];
//AGB versions go here
export const agbSection: FileCategoryKunden[] = [
{
    germanTitle: "AGB 11.04.2025",
    englishDescription: "agb_250411",
    fileUrl: "AGB_c3_250411.pdf",
  },



];

/**
 * Array of industrial water sections, each containing a German title, English description, and optional subsections.
 * 
 * @type {FileCategoryKunden[]}
 */
export const industrialWaterSection: FileCategoryKunden[] = [
  {
    germanTitle: "Ausschreibungstexte",
    englishDescription: "tender_documents",
    subSections: [
      {
        title: "Absalzplatten/Bypass VDI 6044",
        files:[]
      },
      {
        title: "Chemie",
        files: [
          {
            fileName: "LV Korrosionsschutz",
            fileUrl: "LV Korrosionsschutz.pdf",
          },
          {
            fileName: "LV Stabilisatoren",
            fileUrl: "LV Stabilisatoren.pdf",
          },
          {
            fileName: "LV Biozide & Dispergatoren",
            fileUrl: "LV Biozide & Dispergatoren.pdf",
          },
          {
            fileName: "LV Kombiprodukte",
            fileUrl: "LV Kombiprodukte.pdf",
          },
        ]
      },
      {
        title: "Enthärtungsanlagen",
        files:[
          {
            fileName: "DWF5-SX Tabelle",
            fileUrl: "DWF5-SX Tabelle.png",
          },
          {
            fileName: "VAK CK Tabelle",
            fileUrl: "VAK CK Tabelle.png",
          },
          {
            fileName: "VAS CK Tabelle",
            fileUrl: "VAS CK Tabelle.png",
          },
          {
            fileName: "LV Enthärtungsanlagen",
            fileUrl: "LV Enthärtungsanlagen.pdf",
          },
        ]
      },
      {
        title: "Filter",
        files:[
          {
            fileName: "LV Filteranlagen",
            fileUrl: "LV Filteranlagen.pdf",
          }
        ]
      },
      {
        title: "Pumpen",
        files:[]
      },
      {
        title: "Sprinkler",
        files:[]
      },
      {
        title: "Umkehrosmose",
        files:[
          {
            fileName: "UOR Tabelle",
            fileUrl: "UOR_Tabelle.png",
          },
          {
            fileName: "UON Tabelle3",
            fileUrl: "UON_Tabelle3.png",
          },
          {
            fileName: "UON Tabelle2",
            fileUrl: "UON_Tabelle2.png",
          },
          {
            fileName: "UON Tabelle",
            fileUrl: "UON_Tabelle.png",
          },
          {
            fileName: "LV Umkehrosmoseanlagen",
            fileUrl: "LV Umkehrosmoseanlagen.pdf",
          },
        ]
      },
      {
        title :"Sonstiges",
        files:[]
      },
      {
        title: "Dosiertechnik",
        files: [
          {
            fileName: "LV Dosiertechnik",
            fileUrl: "LV Dosiertechnik.pdf",
          },
        ]
      }
    ]
  }
];

/**
 * Array of Coracon sections, each containing a German title, English description, and optional subsections.
 * 
 * @type {FileCategoryKunden[]}
 */
export const CoraconSection: FileCategoryKunden[] = [
  {
    germanTitle: "Ausschreibungstexte",
    englishDescription: "tender_documents",
    subSections: [
      {
        title: "WTF Geothermie",
        files:[
          {
            fileName: "LV Wärmeträger Geothermie",
            fileUrl: "LV Wärmeträger Geothermie.pdf",
          }
        ]
      },
      {
        title: "WTF Solarthermie",
        files: []
      },
      {
        title: "WTF Gebäude- und Anlagentechnik",
        files:[
          {
            fileName: "LV Wärmeträger Industrie- und Gebäudetechnik",
            fileUrl: "LV Wärmeträger Industrie- und Gebäudetechnik.pdf",
          }
        ]
      },
      {
        title: "Heizung",
        files:[
          {
            fileName: "LV Wärmeträger Heizung",
            fileUrl: "LV Wärmeträger Heizung.pdf",
          }
        ]
      },
      {
        title: "Superkonzentrate",
        files:[]
      },
      {
        title: "Sonstiges",
        files:[]
      },
    ]
  }
];

export const c3GuideFiles: FileCategoryKunden[] = [
  {
    germanTitle: "Gesamtanleitung c3",
    englishDescription: "general_instructions_c3",
    fileUrl: "Gesamtanleitung c3.pdf",
  },
];